import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'th0062',
    ecrans: ['00-2']
});
